// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 export const environment = {
  production: false,
  // protheus : 'https://prxrp.fsb.com.br/rest/FSB_COMUNICACAO', // producao
  protheus: 'https://fornecedor-api-hml.fsbholding.com.br/rest/FSB_COMUNICACAO', // homologacao
  baseURL: 'https://fornecedor-api-hml.fsbholding.com.br',
}; 
 */


  export const environment = {
  production: false,
  protheus: 'https://fornecedor-api.fsbholding.com.br/rest/FSB_COMUNICACAO',
  baseURL: 'https://fornecedor-api.fsbholding.com.br',
}; 

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
